import { render, staticRenderFns } from "./import-archive-modal.vue?vue&type=template&id=3509b649&scoped=true&"
import script from "./import-archive-modal.vue?vue&type=script&lang=ts&"
export * from "./import-archive-modal.vue?vue&type=script&lang=ts&"
import style0 from "./import-archive-modal.vue?vue&type=style&index=0&id=3509b649&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509b649",
  null
  
)

export default component.exports